export const ANDROID = 'android';
export const INBOX_VIEW = 'inbox';
export const IN_APP_VIEW = 'in-app';
export const IOS = 'ios';

export const CARD = 'card';
export const THUMBNAIL = 'thumbnail';
export const SMALL_THUMBNAIL = 'small-thumbnail';

export const TEMPLATE_PREVIEW_SIZE_VARIANTS = {
  CARD,
  THUMBNAIL,
  SMALL_THUMBNAIL,
};
